import { Text } from '@chakra-ui/react';
import SelectMy, { TSelectMy } from 'components/SelectMy';
import { ROLES } from 'store/types';

const getOption = (role: string, desk: string) => (
    <Text color="gray.900" fontSize="16px" fontWeight={400} lineHeight={1} letterSpacing="initial">
        {role}
        <Text color="gray.500" as="span">
            {' '}
            – {desk}
        </Text>
    </Text>
);

export const ROLE_OPTIONS = [
    {
        label: getOption('Admin', 'Full access with unlimited permissions'),
        value: ROLES.admin,
    },
    {
        label: getOption('Member', 'Full access with limited permissions'),
        value: ROLES.member,
    },
];

type TRoleDropdown = Omit<TSelectMy, 'options'>;

const RoleDropdown = ({ label, value, onChange, sx }: TRoleDropdown) => {
    return <SelectMy sx={sx} value={value} label={label} onChange={onChange} options={ROLE_OPTIONS} />;
};

export default RoleDropdown;
